import { keysWithMap } from '@infl-ts/util-io-ts';
export var EventType = keysWithMap({
  view: 'view',
  click: 'click'
});